/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ScheduledNotificationBefore { 
    /**
     * Number of units before the event.
     */
    value: number;
    /**
     * Unit of time before the event.
     */
    unit: ScheduledNotificationBefore.UnitEnum;
}
export namespace ScheduledNotificationBefore {
    export type UnitEnum = 'DAYS' | 'HOURS';
    export const UnitEnum = {
        DAYS: 'DAYS' as UnitEnum,
        HOURS: 'HOURS' as UnitEnum
    };
}


